import React from 'react'
import {Route, Switch} from 'react-router-dom'
import LoginPage from './containers/LoginPage'
import HomePage from './containers/HomePage'
import UsersPage from './containers/UsersPage'
import UserEditPage from './containers/UserEditPage'
import InvoicesPage from './containers/InvoicesPage'
import InvoiceEditPage from './containers/InvoiceEditPage'
import PartiesPage from "./containers/PartiesPage";
import TransactionsPage from "./containers/TransactionsPage";
import TransactionEditPage from "./containers/TransactionEditPage";
import PartyEditPage from "./containers/PartyEditPage";


export default (
	<Switch>
		{<Route exact path="/login" component={LoginPage}/>}
		{<Route exact path="/users" component={UsersPage}/>}
		{<Route exact path="/users/new" component={UserEditPage}/>}
		{<Route exact path="/users/:userId/:tab?" component={UserEditPage}/>}
		{<Route exact path="/recover-password/:token" component={HomePage}/>}
		{<Route exact path="/parties" component={PartiesPage}/>}
		{<Route exact path="/parties/new" component={PartyEditPage}/>}
		{<Route exact path="/parties/:partyId/:tab?" component={PartyEditPage}/>}
		{<Route exact path="/invoices" component={InvoicesPage}/>}
		{<Route exact path="/invoices/new" component={InvoiceEditPage}/>}
		{<Route exact path="/invoices/:invoiceId/:tab?" component={InvoiceEditPage}/>}
		{<Route exact path="/transactions" component={TransactionsPage}/>}
		{<Route exact path="/transactions/new" component={TransactionEditPage}/>}
		{<Route exact path="/transactions/:transactionId/:tab?" component={TransactionEditPage}/>}
		{<Route exact path="/:tab?/:year?/:period?" component={HomePage}/>}
	</Switch>
);
